import { useMutation, useQueryClient } from "react-query";
import * as notify from "shared/notify";
import { createAttributeFeedback, updateAttributeFeedback } from "components/attributes/attribute-feedback/lib/data";
import { attributeFeedbackQueryKey, FEEDBACK_SAVED_MESSAGE } from "components/attributes/attribute-feedback/lib/constants";

export const useSaveAttributeFeedback = (taskKey) => {
    const queryClient = useQueryClient();
    const refreshFeedback = () => queryClient.invalidateQueries([attributeFeedbackQueryKey, taskKey]);

    return useMutation(
        async ({ id, payload }) => {
            const response = id ? await updateAttributeFeedback(id, payload) : await createAttributeFeedback(taskKey, payload);

            // 'shared/data' resolves to the 'defaultReturn' on a 409/404 after notifying the user.
            // Reject so the success toast is skipped and the modal stays open with the user's input.
            if (!response) {
                throw new Error("Attribute feedback was not saved");
            }

            return response;
        },
        {
            onSuccess: () => {
                notify.success(FEEDBACK_SAVED_MESSAGE);
                refreshFeedback();
            },
            // A rejected POST is most likely a 409 - feedback for this attribute already exists, reload it.
            onError: refreshFeedback,
        }
    );
};
